const mergeState = (currentState, incomingState) => Object.assign(
  {},
  currentState,
  incomingState,
);

const setBookingData = (state, data) => {
  state.bookingData = data;
};

const setBookingLoading = (state, bookingLoading) => {
  state.bookingLoading = bookingLoading;
};

const resetContacts = state => {
  state.contactComponentData.contacts = [];
};

const pushContact = (state, contact) => {
  state.contactComponentData.contacts = [...state.contactComponentData.contacts, contact];
};

const removeContact = (state, personId) => {
  state.contactComponentData.contacts = state.contactComponentData.contacts
    .filter(contact => contact.personId !== personId);
};

const setContactRole = (state, role) => {
  state.contactComponentData.role = role;
};

const setDate = (state, data) => {
  state.dateComponentData = mergeState(state.dateComponentData, data);
};

const setLocation = (state, data) => {
  state.locationComponentData = data;
};

const setEmail = (state, data) => {
  state.emailComponentData = mergeState(state.emailComponentData, data);
};

const setEstimate = (state, invoiceEstimate) => {
  state.servicesComponentData.estimate = invoiceEstimate || null;
};

const setEstimateError = (state, error) => {
  state.servicesComponentData.estimateError = error;
};

const setEstimateLoading = (state, isLoading) => {
  state.servicesComponentData.estimateLoading = isLoading;
};

const setReachedSummary = (state, summaryReached) => {
  state.reachedSummary = summaryReached;
};

const setTimeUnavailable = (state, timeUnavailable) => {
  state.bookingErrors.timeUnavailable = timeUnavailable;
};

const setApiError = (state, apiError) => {
  state.bookingErrors.apiError = apiError;
};

const clearErrors = state => {
  const keys = Object.keys(state.bookingErrors);
  keys.forEach(key => {
    state.bookingErrors[key] = false;
  });
};

/**
 * Adds service to selectedServices collection if it does not
 * exist in current collection; otherwise updates existing service
 * with matching id.
 *
 * @param {object<VuexState>} state
 * @param {service} service
 */
const addService = (state, service) => {
  const incomingServiceId = service.id;
  if (!incomingServiceId) {
    return;
  }

  const serviceExists = state.servicesComponentData.selectedServices
    .some(selectedService => selectedService.id === incomingServiceId);

  if (serviceExists) {
    state.servicesComponentData.selectedServices = state.servicesComponentData.selectedServices
      .map(selectedService => (selectedService.id === incomingServiceId
        ? service
        : selectedService));
  } else {
    state.servicesComponentData.selectedServices.push(service);
  }
};

/**
 * Remove a Service from the selectedServices collection if it exists
 * in the current selectedServices collection.
 *
 * @param {object<VuexState>} state
 * @param {string<uuid>} serviceId
 */
const removeService = (state, serviceId) => {
  const serviceExists = state.servicesComponentData.selectedServices
    .some(selectedService => selectedService.id === serviceId);

  if (!serviceExists) {
    return;
  }

  state.servicesComponentData.selectedServices = state.servicesComponentData.selectedServices
    .filter(selectedService => selectedService.id !== serviceId);
};

/**
 * Set selectedServices collection to new collection. Will reset
 * selectedServices collection to empty array if falsy, or no, value
 * is provided.
 *
 * @param {object<VuexState>} state
 * @param {array<service>} services
 */
const setServices = (state, services) => {
  if (!services) {
    state.servicesComponentData.selectedServices = [];
    return;
  }

  state.servicesComponentData.selectedServices = services;
};

/**
 * Set appointment custom fields
 * @param {object<VuexState>} state
 * @param {array<customField>} customFieldDefinitions
 */

const setCustomFields = (state, customFieldDefinitions) => {
  state.appointmentCustomFields = customFieldDefinitions;
};

export default {
  setBookingData,
  setBookingLoading,
  resetContacts,
  pushContact,
  removeContact,
  setContactRole,
  setDate,
  setEmail,
  setEstimate,
  setEstimateError,
  setEstimateLoading,
  setLocation,
  setReachedSummary,
  setTimeUnavailable,
  setApiError,
  clearErrors,
  addService,
  removeService,
  setServices,
  setCustomFields,
};
